export default __webpack_public_path__ + "static/media/hero_bg_mobile.94831095.png";